import React from "react";
import "./containers.css";
import Header from "../Header/Header";
import { LayoutPropsInterface } from "../../utils/constants/Interfaces.constants";
import { useState } from "react";

const LayoutContainer: React.FunctionComponent<LayoutPropsInterface> = ({
  children,
  title,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    // Initialize state from local storage
    const storedValue = localStorage.getItem("isCollapsed");
    return storedValue === "true";
  });

  return (
    <div className="right-pane-layout">
      <div className="admin-header">
        <Header title={title} />
      </div>
      <div className="main-content-container">{children}</div>
    </div>
  );
};

export default LayoutContainer;
